<template>
    <b-card no-body>
      <template v-slot:header>
        <b-row v-if="!editing">
          <b-col>
            <b-form-select :options="[{value: null, text: 'Status'}, 'pending', 'complete', 'error', 'deleted']" v-model="filter_status" class="mr-2" size='sm' style='max-width: 120px' @change="search" />
            <b-form-select :options="[{value: null, text: 'QC status'}, 'review', 'skip', 'pass', 'fail', 'bin']" v-model="filter_quality_control_status" class="mr-2" size='sm' style='max-width: 120px' @change="search" />
            <b-form-select :options="[{value: null, text: 'Event'}, 'visited', 'played', 'finished', 'clicked', 'not visited', 'not played', 'not finished', 'not clicked']" v-model="filter_event" class="mr-2" size='sm' style='max-width: 120px' @change="search" />
            <LoadingButton class="px-1" @click="search" :only_loading="true" :loading="loading" variant='none' size='sm' key="1"><i class="far fa-sync-alt" key="2"></i></LoadingButton>
            <b-button v-if="profile.role === 'admin'" class="px-1" @click="editing = !editing" key='b' variant='none' size='sm'><i class="far fa-edit"></i></b-button>
          </b-col>
          <b-col>
            <div>
            <!-- <b-button size="sm" variant="primary float-right" :to="{name: `${collection}_create`}" :disabled="profile.team.plan === null || project.status === 'pending' || profile.avatar.status != constants.voice_status.complete">Create</b-button> -->
            <b-button size="sm" variant="primary" class="float-right" :to="{name: `${collection}_batch_create`}"  :disabled="profile.team.plan === null || project.status === 'pending' || profile.avatar.status != constants.voice_status.complete">Create</b-button>
            <LoadingButton :loading="exporting" size="sm" variant="secondary" class="float-right mr-2" @click="export_items">Export</LoadingButton>
          </div>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col>
            <b-button class="px-1" @click="editing = !editing" variant='none' size='sm'><i class="fas fa-times-circle" key='a'></i></b-button>
            <span class='p-1'>{{selected.length}} items selected</span>
          </b-col>
          <b-col>
            <div>
              <LoadingButton :loading="qc_pass_loading" size="sm" variant="warning" class="mr-2 float-right" @click="pass_items">Pass QC</LoadingButton>
              <LoadingButton :loading="retry_loading" size="sm" variant="warning" class="mr-2 float-right" @click="retry_items">Retry</LoadingButton>
              <!-- <b-form-select class="mr-2 float-right" :options="['pending', 'processing', 'complete', 'error']" v-model="filter_status" size='sm' style='max-width: 120px' @change="search"/> -->
            </div>
          </b-col>
        </b-row>
      </template>

      <b-table ref="table" show-empty :items="items" @row-clicked="view_row" hover class="clickable" :fields="table_fields" selectable select-mode='range' selected-variant='secondary' @row-selected="on_selected">
        <template v-slot:cell(updated)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(created)='data'>
          {{data.value | date}}
        </template>
        <template v-slot:cell(status)='data'>
          <b-badge :class='`status-${data.value}`'>{{data.value}}</b-badge>
        </template>
        <template v-slot:cell(quality_control_status)='data'>
          <b-badge :class='`status-${data.value}`'>{{data.value}}</b-badge>
        </template>
        <template v-slot:cell(events)='data'>
          <div class='p-1'>
            <span v-if="data.item.visited" v-b-tooltip.hover :title="`Video visited ${data.item.visited} times`" class='mr-1'><i class="fas fa-eye"></i></span>
            <span v-if="data.item.played" v-b-tooltip.hover :title="`Video played ${data.item.played} times`" class='mr-1'><i class="fas fa-play"></i></span>
            <span v-if="data.item.finished" v-b-tooltip.hover :title="`Video finished ${data.item.finished} times`" class='mr-1'><i class="fas fa-flag-checkered"></i></span>
            <span v-if="data.item.clicked" v-b-tooltip.hover :title="`CTA clicked ${data.item.clicked} times`" class='mr-1'><i class="fas fa-mouse-pointer"></i></span>
          </div>
        </template>
      </b-table>

      <template v-slot:footer>
        <b-form inline>
          <b-button-toolbar>
            <b-button-group size="sm">
              <LoadingButton size="sm" @click="search('previous_page')" :disabled="current_page == 0" :loading="previous_page_loading">&lsaquo; Last</LoadingButton>
            </b-button-group>
            <b-button-group class="ml-2" size="sm">
              <LoadingButton size="sm" @click="search('next_page')" :disabled="items.length != page_size || no_more_results" :loading="next_page_loading">Next &rsaquo;</LoadingButton>
            </b-button-group>
          </b-button-toolbar>

          <b-form-select :options="page_size_options" v-model="page_size" @change="search" size="sm" class='ml-2'></b-form-select>
        </b-form>

      </template>
    </b-card>
</template>

<script>

import { db, FieldValue } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'

export default {
  name: 'project_item_list',
  metaInfo: {title: 'Items'},
  mixins: [ItemMixin],
  props: ['project', 'profile'],
  // firestore: function () {
  //   return {
  //     items: db.collection('project').doc(this.$route.params.id).collection(this.collection).orderBy('created', 'desc')
  //   }
  // },
  data() {
    let table_fields = ['name', 'status', {label: 'QC', key: 'quality_control_status'}, 'events', 'updated', 'created']

    return {
      collection: 'item',
      filter_status: this.$route.query.status || null,
      filter_quality_control_status: this.$route.query.quality_control_status || null,
      filter_event: this.$route.query.event || null,
      exporting: false,
      table_fields: table_fields,
      editing: false,
      selected: [],
      retry_loading: false,
      qc_pass_loading: false,
    }
  },
  methods: {
    async retry_items() {
      this.retry_loading = true
      let proms = []
      for (let item of this.selected) {
        console.log(item)
        proms.push(this.retry_item(item.id))
      }
      await Promise.all(proms)

      this.$refs.table.clearSelected()
      this.editing = false

      this.search()

      this.retry_loading = false
    },
    async pass_items() {
      this.qc_pass_loading = true
      let proms = []
      for (let item of this.selected) {
        proms.push(await db.collection('project').doc(this.$route.params.id).collection('item').doc(item.id).update({quality_control_status: 'pass', quality_control_review_count: FieldValue.increment(1), quality_control_updated: new Date()}))
      }
      await Promise.all(proms)

      this.$refs.table.clearSelected()
      this.editing = false

      this.search()

      this.qc_pass_loading = false
    },
    async retry_item(item_id) {
      await db.collection('project').doc(this.$route.params.id).collection('item').doc(item_id).update({updated: new Date(), status: 'error', error_message: 'Manually marked as error'})
      await db.collection('project').doc(this.$route.params.id).collection('item').doc(item_id).update({updated: new Date(), status: 'pending', video_url: null, quality_control_status: 'pending', quality_control_updated: new Date()})
    },
    on_selected(items) {
      this.selected = items
    },
    async search(action) {
      this.loading = true
      let query = db.collection('project').doc(this.$route.params.id).collection(this.collection)

      let query_params = {}
      if (this.filter_status) {
        query = query.where('status', '==', this.filter_status)
        query_params.status = this.filter_status
      } else {
        query = query.where('status', 'in', ['pending', 'processing', 'complete', 'error'])
      }

      if (this.filter_quality_control_status) {
        query = query.where('quality_control_status', '==', this.filter_quality_control_status)
        query_params.quality_control_status = this.filter_quality_control_status
      }

      if (this.filter_event) {
        if (this.filter_event === 'visited') {
          query = query.where('visited', '>', 0).orderBy('visited')
        }
        if (this.filter_event === 'played') {
          query = query.where('played', '>', 0).orderBy('played')
        }
        if (this.filter_event === 'finished') {
          query = query.where('finished', '>', 0).orderBy('finished')
        }
        if (this.filter_event === 'clicked') {
          query = query.where('clicked', '>', 0).orderBy('clicked')
        }
        if (this.filter_event === 'not visited') {
          query = query.where('visited', '==', 0)
        }
        if (this.filter_event === 'not played') {
          query = query.where('played', '==', 0)
        }
        if (this.filter_event === 'not finished') {
          query = query.where('finished', '==', 0)
        }
        if (this.filter_event === 'not clicked') {
          query = query.where('clicked', '==', 0)
        }
        query_params.event = this.filter_event
      }

      query = query.orderBy('created', 'desc')

      if (JSON.stringify(this.$route.query) != JSON.stringify(query_params)) {
        this.$router.replace({query: query_params})
      }

      if (action == 'next_page') {
        this.next_page_loading = true
        let last_item = this.items[this.items.length-1]
        query = query.startAfter(last_item.doc).limit(this.page_size)
        this.current_page++
      } else if (action == 'previous_page') {
        this.previous_page_loading = true
        let first_item = this.items[0]
        query = query.endBefore(first_item.doc).limitToLast(this.page_size)
        this.current_page--
      } else if (action === 'export') {
        // pass
      } else {
        query = query.limit(this.page_size)
        this.current_page = 0
      }

      let docs = await query.get()

      if (action === 'export') {
        let items = []
        for (let doc of docs.docs) {
          let item = doc.data()
          item.id = doc.id
          item.doc = doc
          items.push(item)
        }

        this.loading = false

        return items
      }

      if (docs.docs.length > 0 || action != 'next_page') {
        this.no_more_results = false
        let items = []
        for (let doc of docs.docs) {
          let item = doc.data()
          item.id = doc.id
          item.doc = doc
          items.push(item)
        }

        this.items = items
      } else {
        this.no_more_results = true
        this.current_page--
      }

      if (this.items.length > 0) {
        if (action != 'previous_page') {
          // Peak ahead
          let docs = await query.startAfter(this.items[this.items.length-1].doc).limit(1).get()
          if (docs.docs.length === 0) {
            this.no_more_results = true
          } else {
            this.no_more_results = false
          }
        }
      }

      this.next_page_loading = false
      this.previous_page_loading = false
      this.loading = false
      this.$forceUpdate()
    },
    view_row(item) {
      if (this.editing === false) {
        this.$router.push({name: this.collection, params: {item: item.id, from_item: item}})
      }
    },
    async export_items() {
      this.exporting = true
      let csv = "data:text/csv;charset=utf-8,";
      csv += `name,website,video_url,video_player_url,thumbnail_url\r\n`

      let items = await this.search('export')

      for (let item of items) {
        csv += `${item.name},${item.website},${item.video_url},${item.video_player_url},${item.thumbnail_url || this.project.thumbnail_url}\r\n`
      }

      var link = document.createElement("a")
      link.setAttribute("href", encodeURI(csv))
      link.setAttribute("download", "items.csv")
      document.body.appendChild(link)

      link.click()
      this.exporting = false
    }
  },
  created() {
    this.search()
  },
  activated () {
    this.search()
  },
  watch: {
    project: {
      deep: true,
      handler: function(project, old_project) {
        if (project.pending_count !== old_project.pending_count) {
          if (project.pending_count % 3 === 0 || (!old_project.pending_count && project.pending_count === 1)) {
            this.search()
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
